import React from "react";
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getApi } from "../../api/endpoints";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { selectQueryParams, setQueryParams, updateQueryParams } from "../../ui/customerListingReducer";

const BlockModal = (props) => {
  const {showBlockModal, setShowBlockModal, rfidDetails} = props;
  const [blockRfidApi] = getApi('blockRfid');
  const [unBlockRfidApi] = getApi('unBlockRfid');
  const queryParams = useSelector(selectQueryParams);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    setShowBlockModal(false);
  }

  const onBlockRfidClick = async () => {
    try{
      const response = await blockRfidApi({serial_no: `${rfidDetails.serial_no}`}).unwrap();
      setShowBlockModal(false);
      toast.success(response.message || 'VoltUp ID Card Blocked !');
      dispatch(updateQueryParams(setQueryParams(queryParams)));
    } catch(error) {
      setShowBlockModal(true);
      toast.error(error?.message || 'Something went wrong !');
    }
  }

  const onUnblockRfidClick = async () => {
    try{
      const response = await unBlockRfidApi({serial_no: `${rfidDetails.serial_no}`}).unwrap();
      setShowBlockModal(false);
      toast.success(response.message || 'VoltUp ID Card Unblocked !');
      dispatch(updateQueryParams(setQueryParams(queryParams)));
    } catch(error) {
      setShowBlockModal(true);
      toast.error(error?.message || 'Something went wrong !');
    }
  }

  return <>
    {rfidDetails?.status === 'blocked' ?
      <Modal
        show={showBlockModal}
        onHide={handleModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
          className="text-white"
          closeButton
        >
          <Modal.Title>Unblock Voltup ID Card</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='text-center m-2 text-warning'><FontAwesomeIcon icon={faCircleExclamation} style={{ fontSize: '80px'}}/></div>
          <p className='h4 text-center my-3 opacity-75'>Are you sure ?</p>
          <p className='h6 text-center my-3 opacity-75 fw-normal'>
            You want to unblock <span className="fw-bold">{rfidDetails.serial_no} - {rfidDetails.owner_name} ({rfidDetails.id})</span> ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-sm rounded-5 btn-outline-secondary" style={{ width: "80px", fontSize: '16px' }} onClick={handleModalClose}>
            Cancel
          </button>
          <button type='submit' className='btn btn-sm add-button' style={{ width: "80px", fontSize: '16px' }} onClick={(e) => {e.preventDefault(); onUnblockRfidClick()}}>
            Unblock
          </button>
        </Modal.Footer>
      </Modal> :
      <Modal
        show={showBlockModal}
        onHide={handleModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
          className="text-white"
          closeButton
        >
          <Modal.Title>Block Voltup ID Card</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='text-center m-2 text-warning'><FontAwesomeIcon icon={faCircleExclamation} style={{ fontSize: '80px'}}/></div>
          <p className='h4 text-center my-3 opacity-75'>Are you sure ?</p>
          <p className='h6 text-center my-3 opacity-75 fw-normal'>
            You want to block <span className="fw-bold">{rfidDetails.serial_no} - {rfidDetails.owner_name} ({rfidDetails.id})</span> ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-sm rounded-5 btn-outline-secondary" style={{ width: "80px", fontSize: '16px' }} onClick={handleModalClose}>
            Cancel
          </button>
          <button type='submit' className='btn btn-sm remove-button' style={{ width: "80px", fontSize: '16px' }} onClick={(e) => {e.preventDefault(); onBlockRfidClick()}}>
            Block
          </button>
        </Modal.Footer>
      </Modal>
    }
  </>
}

export default BlockModal;